module.exports = __webpack_public_path__ + "static/media/SamuraiFraserMenu.80a49ac8.pdf";